var _rect, _path, _path2, _path3, _path4, _circle, _path5, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteFailedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#ECF1F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8828 27.2969H30.5019V37.0112H28.8828V27.2969Z",
    fill: "#FF7A7A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7422 27.2969H35.3612V37.0112H33.7422V27.2969Z",
    fill: "#FF7A7A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4062 22.4414V24.0605H24.0253V40.2509C24.0253 40.6803 24.1959 41.0921 24.4995 41.3958C24.8031 41.6994 25.2149 41.87 25.6443 41.87H38.5967C39.0261 41.87 39.4379 41.6994 39.7416 41.3958C40.0452 41.0921 40.2158 40.6803 40.2158 40.2509V24.0605H41.8348V22.4414H22.4062ZM25.6443 40.2509V24.0605H38.5967V40.2509H25.6443Z",
    fill: "#FF7A7A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8828 19.2031H35.359V20.8222H28.8828V19.2031Z",
    fill: "#FF7A7A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.6047,
    cy: 42.4016,
    r: 4.3,
    fill: "#FF7A7A",
    stroke: "#FF7A7A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0133 41.1421V43.1441C42.0133 43.3565 42.0028 43.5653 41.9818 43.7706C41.9608 43.9736 41.934 44.1895 41.9013 44.4181H41.3133C41.2806 44.1895 41.2538 43.9736 41.2328 43.7706C41.2118 43.5653 41.2013 43.3565 41.2013 43.1441V41.1421H42.0133ZM41.0648 45.7271C41.0648 45.6548 41.0776 45.586 41.1033 45.5206C41.1313 45.4553 41.1686 45.3993 41.2153 45.3526C41.2643 45.306 41.3215 45.2686 41.3868 45.2406C41.4521 45.2126 41.5221 45.1986 41.5968 45.1986C41.6691 45.1986 41.738 45.2126 41.8033 45.2406C41.8686 45.2686 41.9246 45.306 41.9713 45.3526C42.0203 45.3993 42.0588 45.4553 42.0868 45.5206C42.1148 45.586 42.1288 45.6548 42.1288 45.7271C42.1288 45.8018 42.1148 45.8718 42.0868 45.9371C42.0588 46.0001 42.0203 46.055 41.9713 46.1016C41.9246 46.1483 41.8686 46.1845 41.8033 46.2101C41.738 46.2381 41.6691 46.2521 41.5968 46.2521C41.5221 46.2521 41.4521 46.2381 41.3868 46.2101C41.3215 46.1845 41.2643 46.1483 41.2153 46.1016C41.1686 46.055 41.1313 46.0001 41.1033 45.9371C41.0776 45.8718 41.0648 45.8018 41.0648 45.7271Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    opacity: 0.7,
    x1: 4.89245,
    y1: 48.7349,
    x2: 56.8925,
    y2: 11.9349,
    stroke: "#BDBDBD",
    strokeWidth: 8
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFailedIcon);
export default __webpack_public_path__ + "static/media/DeleteFailedIcon.6fc09b917f3408984b6e4d086a4b2727.svg";
export { ForwardRef as ReactComponent };